import React from 'react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { problems, problemsSection } from '../data/content';
export function Problems() {
  return <section aria-labelledby="problems-heading" className="w-full bg-ivory px-5 py-14 md:px-8 md:py-24" data-id="element-147" data-mp="324svanki9425">
      <div className="mx-auto w-full max-w-content" data-id="element-148" data-mp="2y48th6ozlc9o">
        <Reveal data-id="element-149" data-mp="2y1monethdav5">
          <SectionHeading id="problems-heading" title={problemsSection.title} intro={problemsSection.intro} data-id="element-150" data-mp="2t431tqipvprl" />
        </Reveal>

        <ul className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3 md:mt-14" data-id="element-151" data-mp="2o7cmx6inf07r">
          {problems.map((problem, index) => <Reveal as="li" key={problem} delay={index % 3 * 0.04} className="flex h-full gap-4 rounded-xl border border-charcoal/10 bg-white p-6" data-id="element-152" data-mp="2f4v1guatiblt" data-mpi={index}>
              <span aria-hidden="true" className="mt-3 h-px w-5 shrink-0 bg-brass" data-id="element-153" data-mp="dcykv69smbk6" />
              <span className="text-base font-medium leading-relaxed text-charcoal md:text-[17px]" data-id="element-154" data-mp="34qbs5nnz52ff">
                {problem}
              </span>
            </Reveal>)}
        </ul>

        <Reveal delay={0.06} data-id="element-155" data-mp="2vqgftfion1dt">
          <p className="mx-auto mt-12 max-w-2xl text-center font-serif text-[1.75rem] font-medium italic leading-snug text-forest md:mt-14 md:text-[2rem]" data-id="element-156" data-mp="2vri10ctex499">
            {problemsSection.closing}
          </p>
        </Reveal>
      </div>
    </section>;
}